import { createIcon } from './icon-utils';

export const SmallDoubleCheckIcon = createIcon({
  path: 'M4.46552 11.7694L0.929688 8.23354L1.64252 7.53104L4.47585 10.3644L4.70652 10.1335L5.40919 10.836L4.46552 11.7694ZM8.23219 11.7694L4.69635 8.23354L5.39885 7.5207L8.23219 10.354L14.3655 4.2207L15.068 4.93354L8.23219 11.7694ZM8.00136 8.23354L7.28852 7.53104L10.5885 4.23104L11.3014 4.93354L8.00136 8.23354Z',
  style: { height: 16, width: 16 },
  viewBox: '0 0 16 16',
});
